/* unplugin-vue-components disabled */import script from "./MapPieceManager.vue?vue&type=script&setup=true&lang=js"
export * from "./MapPieceManager.vue?vue&type=script&setup=true&lang=js"

import "./MapPieceManager.vue?vue&type=style&index=0&id=721ee31f&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-721ee31f"]])

export default __exports__